export const Language = {
  ZH_CN: 'zh_cn',
  ZH_TW: 'zh_tw',
  EN_US: 'en_us',
};
